import Template from '../../component/Template.js';
import { useEffect, useRef } from 'react';
import Api from '../../component/Api';
import { useState } from 'react';
import React from "react";
import { useNavigate } from 'react-router-dom';
import useAuth from '../../component/useAuth.js';
import { ToastContainer, toast } from 'react-toastify';
import { Link } from 'react-router-dom';


import Select from 'react-select'; //04-03-2024-multiselect

import 'react-toastify/dist/ReactToastify.css';
import '../../Assets/css/resptable.css'
import 'datatables.net';
import 'datatables.net-bs4/css/dataTables.bootstrap4.min.css';
import $ from 'jquery';

export default function ViewStudents() {

  const navigate = useNavigate();
  // CHECKING IF USER IS VALID
  const isAuth = useAuth();
  if (isAuth === false) {
    navigate("/college/")
  }

  const tableRef = useRef(null);

  const [disciplinedata, setDisciplineData] = useState([]);
  const [studentData, setStudentData] = useState([]);


  const [flag, setflag] = useState(false);


  const [admyear, setAdmyear] = useState("");
  const [discipline_id, setDiscipline] = useState("");
  const [errors, setErrors] = useState({ admyear: '', discipline_id: '' });
  const [admissionYears, setAdmissionYears] = useState([]);
  const [admissionYear, setAdmissionYear] = useState(null);
  const [disciplineId, setDisciplineId] = useState(null);
  const [coursetype, setCoursetype] = useState(null); //04-03-2024-[setCoursetype]
  const [totalstudents, setTotalStudents] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredAndSortedData, setfilteredAndSortedData] = useState([]);


  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState({ column: null, direction: 'asc' }); //sort

  const { http } = Api();

  const handleSort = (column) => {
    const newSortBy = {
      column,
      direction: sortBy.column === column && sortBy.direction === 'asc' ? 'desc' : 'asc',
    };
    setSortBy(newSortBy);
  };

  // Function to filter faculty data based on search query and sortBy state
  useEffect(() => {
    const filteredAndSortedData = [...studentData].filter(student => {
      return (
        String(student.apaar_no)?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(student.accountid)?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(student.aadhar_no)?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        String(student.studentname)?.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }).sort((a, b) => {
      if (sortBy.direction === 'asc') {
        return a[sortBy.column] > b[sortBy.column] ? 1 : -1;
      } else {
        return a[sortBy.column] < b[sortBy.column] ? 1 : -1;
      }
    });
    setfilteredAndSortedData(filteredAndSortedData);
  }, [searchQuery, sortBy, studentData]);


  // Function to render sort icon-sort05/03/2024
  const renderSortIcon = (columnName) => {
    if (sortBy.column === columnName) {
      return sortBy.direction === 'asc' ? <i className="fa fa-sort-up ml-1" aria-hidden="true"></i> : <i className="fa fa-sort-down ml-1" aria-hidden="true"></i>;
    }
    return <i className="fa fa-sort ml-1" aria-hidden="true"></i>; // Show disabled sort icon
  };

  useEffect(() => {
    const fetchAdmissionYears = async () => {
      try {
        const response = await http.get('/Admin/getActiveAdmissionYear');
        const years = response.data.map((year) => ({
          id: year.id,
          value: year.admission_year,
          label: year.admission_year
        }));
        setAdmissionYears(years);
      } catch (error) {
        console.error("Error fetching admission years:", error);
      }
    };
    fetchAdmissionYears()
  }, [admissionYear]);

  const handleAdmissionYearChange = (selectedOption) => {
    setAdmissionYear(selectedOption.value);
  };

  let cid = localStorage.getItem("collegeid");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await http.get(`/Admin/getCollegeDisciplines`, {
          params: {
            limit: '500',
            college_id: cid
          }
        });
        if (response.data.status_code === 'ERR5') {
          setflag(true);

        }
        console.log("response", response);
        setDisciplineData(response.data);

      }
      catch (error) {
        if (error.response.data.http_status === 401 && error.response.data.status_code == "ERR9") {
          toast.error("Invalid Token");
          setTimeout(() => {
            navigate("/college/");
          }, 5000);

        }
        else if (error.response.data.http_status === 429 && error.response.data.status_code == "ERR33") {
          toast.error(error.response.data.message);


        }
        else {
          toast.error("Something went wrong");
        }
        console.error('Error fetching Course data:', error);
      }
    };

    fetchData();
  }, [cid, navigate]);


  const handleDisciplineChange = (selectedOptions) => {


    setDisciplineId(selectedOptions.did);
    setCoursetype(selectedOptions.type);

  };



  const handleSearchInputChange = (event) => {
    setSearchQuery(event.target.value);
  };
  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  useEffect(() => {

    const viewStudentList = async () => {


      try {
        // Make the API call using await
        const response2 = await http.get(`/College/viewStudentList`, {
          params: {
            admission_year: admissionYear,
            discipline_id: disciplineId,
            coursetype: coursetype,
            page: currentPage,
          }
        });

        // Log the response and update the student data state
        console.log("response2=", response2);
        setStudentData(response2.data.studentlist.data);
        setTotalPages(Math.ceil(response2.data.studentlist.total / 50));
        setTotalStudents(response2.data.studentlist.total);

      } catch (error) {
        // Handle the error
        console.error("Error fetching student list:", error);
      }

    };

    if (disciplineId && admissionYear) {
      viewStudentList()
    }

  }, [disciplineId, admissionYear, currentPage, coursetype]);

  const encodeID = id => {
    return btoa(id);
  };

  const customStyles = {
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    /* Additional custom scrollbar styling for WebKit-based browsers */
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

  const options = [
    { value: '2024', label: '2024' },
    { value: '2023', label: '2023' }
  ]; 

  //custom discipline style
  const disciplineStyles = {

    option: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();  // SF / AIDED

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      if (state.isSelected) {
        return {
          ...provided,
          backgroundColor: "#ebebeb",
          color: color,   // KEEP suffix color even when selected
          fontWeight: "600",
        };
      }

      return {
        ...provided,
        color: color,
      };
    },

    // THIS makes the selected item in the select box colored
    singleValue: (provided, state) => {
      const label = state.data.label || "";
      const suffix = label.split("-")[1]?.trim();

      let color = "black";
      if (suffix === "SF") color = "#252393";
      if (suffix === "AIDED") color = "green";

      return {
        ...provided,
        color: color,
        fontWeight: "600",
      };
    },
    menu: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
    }),
    menuList: (provided) => ({
      ...provided,
      maxHeight: '200px',
      overflowY: 'auto',
      scrollbarWidth: 'thin',
      scrollbarColor: '#888 #f1f1f1',
    }),
    multiValue: (provided) => ({
      ...provided,
      '&::-webkit-scrollbar': {
        width: '8px',
      },
      '&::-webkit-scrollbar-track': {
        background: '#f1f1f1',
      },
      '&::-webkit-scrollbar-thumb': {
        background: '#888',
        borderRadius: '4px',
      },
      '&::-webkit-scrollbar-thumb:hover': {
        background: '#555',
      },
    }),
  };

    
  return (
    <>
      <ToastContainer />
      <Template>
        <div className="adl-stl-page">
          <div className="container-fluid">
            <div className="row">
              <div className="col-sm-12">
                <div className="card">
                  <div className="col-md-12">
                    <div className="card-header">
                      <div className="py-3 d-flex justify-content-between align-items-center ">
                        <h5>Admitted Students</h5>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">

                    <div className="card-body pdg">
                      <div className="table-responsive">

                        <form className="form theme-form">
                          <div className="card-body custom-input">


                            <div className="col">
                              <div className="row m-b-20">
                                <div className="col-md-6">
                                  <label>Admission Year <span className="errorclr">*</span></label>

                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    styles={customStyles}
                                    options={admissionYears}
                                    onChange={handleAdmissionYearChange}
                                  />
                                  {errors.admyear && <p className="text-danger">{errors.admyear}</p>}
                                </div>




                                <div className="col-md-6">
                                  <label>Discipline <span className="errorclr">*</span></label>

                                  <Select
                                    maxMenuHeight={200}
                                    menuPlacement="auto"
                                    id="discipline_id"
                                    name="discipline_id"
                                    className="form"
                                    styles={disciplineStyles}
                                    onChange={handleDisciplineChange}
                                    options={flag ? [{ value: '0', label: 'No data found' }] : disciplinedata
                                      .sort((a, b) => a.discipline_name.localeCompare(b.discipline_name)) // Sort the colleges array alphabetically
                                      .map(disciplines => ({

                                        did: disciplines.discipline_id,
                                        value: disciplines.discipline_name,
                                        label: disciplines.discipline_name,
                                        type: disciplines.college_course_type

                                      }))}                                     
                                  />

                                  {errors.discipline_id && <p className="text-danger">{errors.discipline_id}</p>}

                                </div>
                              </div>

                            </div>


                            <div className='row'>
                              <div className='col-md-6 wdt' >
                                <p>
                                  Showing {(currentPage - 1) * 50 + 1}{''}-
                                  {Math.min((currentPage - 1) * 50 + 50, totalstudents)} of {totalstudents} entries
                                </p>
                              </div>
                              <div className='col-md-2 wdt' >
                              </div>

                              <div className='col-md-4 wdt' align='right'>
                                <input
                                  type="text"
                                  value={searchQuery}
                                  onChange={handleSearchInputChange}
                                  placeholder="Search..."
                                  className='form-control'
                                /></div></div>


                            <div class="table-container">
                              <table className="display dataTable table-striped table-bordered" ref={tableRef} id="dataTable">
                                <thead>
                                  <tr className="bg-primary">
                                    <th onClick={() => handleSort('created_at')} width="10%">Sl No &nbsp;
                                      {renderSortIcon('created_at')} </th>
                                    <th onClick={() => handleSort('PRN')} width="10%">PRN &nbsp;
                                      {renderSortIcon('PRN')} </th>
                                    <th onClick={() => handleSort('apaar_no')} width="17%">APAAR Id &nbsp;
                                      {renderSortIcon('apaar_no')}</th>
                                    <th width="20%" onClick={() => handleSort('accountid')}>CAP Id/Account ID &nbsp;
                                      {renderSortIcon('accountid')}</th>
                                    <th onClick={() => handleSort('aadhar_no')}>Aadhar No &nbsp;
                                      {renderSortIcon('aadhar_no')}</th>
                                    <th onClick={() => handleSort('studentname')} width="12%">Name &nbsp;
                                      {renderSortIcon('studentname')}</th>
                                    <th scope="col">View</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {filteredAndSortedData.length > 0 ? filteredAndSortedData.map((student, index) => {
                                    const serialNumber = (currentPage - 1) * 50 + index + 1;

                                    return (

                                      <tr key={student.sdid}>

                                        <td data-label="Sl No" className='text-center'>{serialNumber}</td>
                                        <td data-label="PRN" className='text-center'>{student.PRN}</td>
                                        <td data-label="APAAR Id" className='text-center'>{student.apaar_no}</td>
                                        <td data-label="Account Id" className='text-center'>{student.accountid}</td>
                                        <td data-label="Aadhar No" className='text-center'>{student.aadhar_no}</td>
                                        <td data-label="Name" className='text-center'>{student.studentname}</td>

                                        <td data-label="View">

                                          {/* <a class="btn btn-transparent btn-sm" href="javascript:void(0)"><i class="fa fa-link"></i> View profile</a> */}
                                          <ul className="action">
                                            <li className="btn btn-transparent btn-sm"> <Link to={`/college/studentprofile/${encodeID(student.accountid)}`} target="_blank"><i class="fa fa-link"></i>&nbsp;View profile</Link></li>
                                          </ul>
                                        </td>

                                      </tr>
                                    )
                                  }
                                  ) : (
                                    <tr>
                                      <td colSpan="6" className="text-center">No students found</td>
                                    </tr>
                                  )}
                                </tbody>
                              </table>
                            </div>
                            {/* //pagination logic  */}

                            {totalPages > 1 && (
                              <nav aria-label="..." style={{ cursor: "pointer" }}>
                                <ul className="pagination justify-content-center">
                                  <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                    <span className="page-link pgn-clr" onClick={handlePreviousPage}><i class="bi bi-arrow-left-circle-fill"></i></span>
                                  </li>
                                  <li className={`page-item`}>
                                    <span className="page-link pgn-clr" onClick={() => handlePageChange(1)}>1</span>
                                  </li>
                                  {currentPage > 4 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}
                                  {[...Array(totalPages - 1).keys()].slice(currentPage > 4 ? currentPage - 3 : 1, currentPage + 2).map((pageNumber) => (
                                    <li key={pageNumber} className={`page-item ${pageNumber + 1 === currentPage ? 'act-clr' : ''}`}>
                                      <span className="page-link pgn-clr" onClick={() => handlePageChange(pageNumber + 1)}>{pageNumber + 1}</span>
                                    </li>
                                  ))}
                                  {currentPage < totalPages - 3 && <li className="page-item"><span className="page-link pgn-clr">...</span></li>}

                                  <li className={`page-item`}>
                                    <span className="page-link pgn-clr" onClick={() => handlePageChange(totalPages)}>{totalPages}</span>
                                  </li>

                                  <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                    <span className="page-link pgn-clr" onClick={handleNextPage}><i class="bi bi-arrow-right-circle-fill"></i></span>
                                  </li>
                                </ul>
                              </nav>
                            )}


                          </div>



                        </form>



                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>


      </Template>
    </>
  );
}